import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=1eebe7f3&scoped=true&"
var script = {}
import style0 from "./Registration.vue?vue&type=style&index=0&id=1eebe7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebe7f3",
  null
  
)

export default component.exports